import React, { useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  AppBar,
  Toolbar
} from '@mui/material';
import { apiService } from '../services/api';
import { getLogoPath, getAppName } from '../utils/theme';

interface AdminLoginProps {
  onLogin: (adminSecret: string) => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ onLogin }) => {
  const [adminSecret, setAdminSecret] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // Test the admin secret by trying to get clients
      await apiService.getAllClients(adminSecret);
      onLogin(adminSecret);
    } catch (error) {
      setError('Invalid admin secret');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <img
            src={getLogoPath()}
            alt={getAppName()}
            style={{
              width: '32px',
              height: '32px',
              marginRight: '16px'
            }}
          />
          <Typography variant="h6" component="div">
            {getAppName()} - Admin Panel
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
            <img
              src={getLogoPath()}
              alt={getAppName()}
              style={{
                width: '80px',
                height: '80px',
                marginBottom: '16px'
              }}
            />
            <Typography variant="h4" component="h1" gutterBottom>
              Admin Login
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {getAppName()}
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleLogin}>
            <TextField
              fullWidth
              type="password"
              label="Admin Secret"
              value={adminSecret}
              onChange={(e) => setAdminSecret(e.target.value)}
              margin="normal"
              required
              disabled={isLoading}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={isLoading || !adminSecret}
            >
              {isLoading ? 'Verifying...' : 'Login'}
            </Button>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default AdminLogin;